import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
const $= window.$;

class ChatSummary extends Component {
	constructor(props) {
		super(props);
        this.state={
        	booked : [],
        	books : [],
        	call_avail : 0,
        	front:'',
        };
        this.getCalender = this.getCalender.bind(this);
        this.setRate = this.setRate.bind(this);
        this.chatLogs = this.chatLogs.bind(this);
        this.getChat = this.getChat.bind(this);
	}

	chatLogs(slot_id,chatstart,chatends,date){
		let learner_id = Common.getUserData("id", true);
    	let lr_name = Common.getUserData("fullName", true);
    	let domain = Config.domainUrl; 
    	fetch(Config.domainUrl+'ecoach-chat/generate-excel', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learner_id,time_slot_id:slot_id,lr_name:lr_name,chat_start:chatstart,chat_ends:chatends,slot_date:date,domain:domain
              })
            }).then((response) => response.json())
           .then((responseJson) => {
           	if(responseJson.status != 0){
				let path = Config.domainUrl+'download/admin/'+responseJson.data;
                window.open(path, '_blank');
           	}
   		 });
	}

	getChat(ec_id,slot_id){
		// alert(this.props.location.pathname);
		let path =this.state.front+'chat/'+ec_id+'/'+slot_id;
		// alert(path);
		window.open(path, '_blank');
	}

	setRate(time_slot_id,date,time,id){
    	let learner_id = Common.getUserData("id", true);
    	let lr_name = Common.getUserData("fullName", true);
    	let pinid = Common.getUserData("pinID", true);
    	let pinno = Common.getUserData("pinNo", true);
    	let corp_id = Common.getUserData("corporateID",true);
    	let role = Common.getUserData("role",true);
		let rating = $('#'+id).val();
		fetch(Config.domainUrl+'ecoach-chat/rate-call', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learner_id,rating:rating,time_slot_id:time_slot_id,date:date,time:time,lr_name:lr_name,pinid:pinid,pinno:pinno,corp_id:corp_id,role:role
              })
            }).then((response) => response.json())
           .then((responseJson) => {
           	if(responseJson.status != 0){
				Common.message("", responseJson.message, "success");
				this.getList();
           	}
   		 });

	}

    componentWillReceiveProps(nextProps) {
    	this.getList();
	}

	getCalender(call_id,tele_id){
		this.props.setCalender(call_id,tele_id);
	}

	getList(){
		//Common.reactLoader("show", "Please wait...");
    	let learner_id = Common.getUserData("id", true);
    	let pinid = Common.getUserData("pinID", true);
    	let pinno = Common.getUserData("pinNo", true);
    	fetch(Config.domainUrl+'ecoach-chat/booked-details', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learner_id,pinid:pinid,pinno:pinno,
              })
            }).then((response) => response.json())
           .then((responseJson) => {
           	if(responseJson.status != 0){
                this.setState({
                    booked : responseJson.booked,
                    call_avail : responseJson.call_avail,
                    front : responseJson.front_url,
                });
           	}
   		 });

		

	}
   

    componentDidMount() {
        this.getList();
    }




		render() {
			let booked = this.state.booked.map((called,k)=>{
				let id = "cmbRating"+k;
				let rat_div = '';
				let chat_button = '';
				let chat_log = '';
				if(called.completed_state ==1){
					if(called.rating == 0 || called.rating == null){
					rat_div = <div className="orng-box">
								Please rate the E Coach on this telecall from 1 to 10, where <strong>1 means "I am not satisfied at all"</strong> and <strong>10 means "I am extremely happy with it"</strong>.
								<div className="rating">I rate this call as  
									<select name={"cmbRating"+k} id={id} >
										<option value=''>--- Select ---</option>
										<option value='1'>1</option>
										<option value='2'>2</option>
										<option value='3'>3</option>
										<option value='4'>4</option>
										<option value='5'>5</option>
										<option value='6'>6</option>
										<option value='7'>7</option>
										<option value='8'>8</option>
										<option value='9'>9</option>
										<option value='10'>10</option>
									</select>
									<input type="submit" name="btnRate" value="Rate" onClick={()=>this.setRate(called.time_slot_id,called.date,called.time,id)} />
								</div>
							</div>;
					}
					else{
						rat_div = <div className="blue-bg"><strong>I rate this call as  </strong><span className="red-txt">{called.rating+'/10'}</span></div>;
					}

				}
				if(called.completed_state == 1){
					chat_log = <a className="button-accept" title="View chat log" href="javascript:void(0)" onClick={()=>this.chatLogs(called.time_slot_id,called.chatstart,called.chatend,called.date)}>View chat log</a>;
				}

				if(called.chat_button == 'true'){
					chat_button = <a href="javascript:void(0);" style={{padding:'7px 25px'}} className='button-blue' onClick={()=>this.getChat(called.sent_ec,called.sent_slot_id)} alt='Chat with E-Coach' title='Chat with E-Coach'>Chat with E-Coach</a>;
				}

				return(
					<div className="light-graybox" key={`called_${k}`}>
						<ul>
							<li><strong>Date:</strong>{called.date}</li>
							<li><strong>Time:</strong>{called.time}</li>
							<li><strong>Request Status:</strong>{called.status}</li>
						</ul>
						{chat_button}
						{rat_div}
						{chat_log}
					</div>
				)
			})
			
			return (
				<div>
					<section id="semana-scroll-inner" className="scroll">
					    <section className="viewport">
					        <section style={{top: "0px"}} className="overview">
					            <div className="inner-content">
					            	{(this.state.call_avail==1)?<span><h2 className='recap-blue-title'>Chats booked by me</h2>{booked}</span>:
					            	<div className="timebox light-graybox">
										<p>Please get back later to visit your Chat Summary after your Chat with your E-Coach</p>
									</div>
					            	}
					            </div>          
					        </section>
					    </section>
					</section>
				</div>
			);
		}
}

export default ChatSummary;



// WEBPACK FOOTER //
// ./src/personal_interactions/ecoach_request/ChatSummary.js